import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useEffect } from 'preact/hooks';

import NoResults from '../components/NoResults'
import Products from '../components/Products'
import Sidebar from '../components/Sidebar'
import BottomToolbar from '../components/BottomToolbar'
import PlaceholdersList from '../components/PlaceholdersList'
import SelectedFilters from '../components/SelectedFilters'

export default () => {
    const {
        response: { products },
        loading,
        query
    } = useAppState()
    const foundProducts = products && products.total > 0
    const docCount = products?.total ?? 0

    useEffect(() => {
        if (loading == false) {
            // update search page banner text
            let target = `.search_category_header .category_txt_2`
            let target_elm = document.querySelector(target)
            if (target_elm) {
                target_elm.innerHTML = ` ${docCount} results for "${query.query}" `
            }
            // re-init yotpo stars Product.jsx
            yotpoWidgetsContainer.initWidgets(345477)
        }
    }, [loading]);

    return (
        <div id={window.cj.nosto.newSearchFeatureEnabled ? '' : "plp-container"}
            data-nosto-element="search"
            data-nosto-query={query.query}
            data-nosto-docCount={docCount}
            class="search-result-container mt-4"
        >
            {loading ? (
                <PlaceholdersList />
            ) : (
                <>
                    <div id={window.cj.nosto.newSearchFeatureEnabled ? '' : "plp-sidebar"} class={window.cj.nosto.newSearchFeatureEnabled && 'mobile-sticky'}>
                        <div className='mt-4 pb-4'>
                            <Sidebar />
                            <hr class="sticky-break" />
                        </div>
                    </div>
                    {foundProducts ?
                        <div id="plp-main-collection-products">
                            {!window.cj.nosto.newSearchFeatureEnabled && <SelectedFilters />}
                            <Products />
                            <BottomToolbar />
                        </div>
                        : (
                            <NoResults />
                        )
                    }
                </>
            )}
        </div>
    )
}
